// LeadFormEmbedPage — Şirketin kendi sitesine yapıştıracağı lead form embed kodu.
// Hazır HTML/JS snippet + canlı önizleme + test gönder.
import React, { useState, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button, FormField, ListPageHeader } from '../components/ui';
import { toast } from '../components/Toast';

export default function LeadFormEmbedPage() {
  const { company } = useAuth();
  const [copied, setCopied] = useState(null);

  const API_BASE = useMemo(() => {
    if (typeof window !== 'undefined') {
      return window.location.origin;
    }
    return 'https://erp.asistanyazilim.com.tr';
  }, []);

  const code = company?.code || 'YOUR_COMPANY_CODE';

  const htmlSnippet = `<!-- hent Lead Form — başla -->
<form id="hent-lead-form" style="max-width:480px;margin:0 auto;display:flex;flex-direction:column;gap:10px;font-family:system-ui,sans-serif">
  <h3 style="margin:0 0 6px">Bedava Demo İste</h3>
  <input name="name"          placeholder="Ad Soyad *" required style="padding:10px;border:1px solid #d1d9e0;border-radius:6px">
  <input name="company_title" placeholder="Şirket"                  style="padding:10px;border:1px solid #d1d9e0;border-radius:6px">
  <input name="email" type="email" placeholder="E-posta"            style="padding:10px;border:1px solid #d1d9e0;border-radius:6px">
  <input name="phone" type="tel"   placeholder="Telefon"            style="padding:10px;border:1px solid #d1d9e0;border-radius:6px">
  <textarea name="message" rows="3" placeholder="Mesajınız (opsiyonel)" style="padding:10px;border:1px solid #d1d9e0;border-radius:6px;font-family:inherit"></textarea>
  <input name="hp_field" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px"/>
  <button type="submit" style="padding:12px;background:#1d6ef5;color:#fff;border:0;border-radius:6px;font-weight:600;cursor:pointer;font-size:15px">Gönder</button>
  <div id="hent-lead-msg" style="font-size:13px;text-align:center"></div>
</form>
<script>
(function(){
  var f = document.getElementById('hent-lead-form');
  if (!f) return;
  f.addEventListener('submit', async function(e){
    e.preventDefault();
    var data = Object.fromEntries(new FormData(f).entries());
    data.company_code = '${code}';
    data.source = data.source || 'Web Form';
    var msg = document.getElementById('hent-lead-msg');
    msg.textContent = 'Gönderiliyor...'; msg.style.color = '#5a6a7e';
    try {
      var r = await fetch('${API_BASE}/api/public/leads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      var j = await r.json();
      if (j.success) {
        msg.textContent = j.message || 'Teşekkürler, en kısa sürede dönüş yapacağız.';
        msg.style.color = '#16a34a';
        f.reset();
      } else {
        msg.textContent = j.message || 'Hata oluştu';
        msg.style.color = '#dc2626';
      }
    } catch (err) {
      msg.textContent = 'Bağlantı hatası, tekrar deneyin';
      msg.style.color = '#dc2626';
    }
  });
})();
</script>
<!-- hent Lead Form — son -->`;

  const apiSnippet = `// REST API ile programatik kullanım
fetch('${API_BASE}/api/public/leads', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    company_code: '${code}',
    name:          'Ahmet Yılmaz',
    company_title: 'Yılmaz Tekstil A.Ş.',
    email:         'ahmet@yilmaztekstil.com',
    phone:         '0532 123 45 67',
    message:       '14 günlük demo istiyorum',
    source:        'web', // 'web' | 'instagram' | 'fuar' | 'soğuk'
  })
})
.then(r => r.json())
.then(console.log);`;

  const copy = (text, key) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(key);
      toast.success('Panoya kopyalandı');
      setTimeout(() => setCopied(null), 2000);
    });
  };

  return (
    <div className="stocks-page" style={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
      <ListPageHeader title="Web Lead Form" unit="" count={null} />

      <div style={{ padding: 16, maxWidth: 1100, margin: '0 auto', width: '100%', flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        <div style={S.infoBox}>
          <strong style={{ color: 'var(--accent-primary)' }}>🌐 Web Lead Form</strong>
          <p style={S.infoP}>
            Aşağıdaki HTML kodunu şirket web sitenize yapıştırın. Müşteriler formu doldurduğunda
            otomatik olarak <strong>Potansiyel Cariler</strong> ve <strong>CRM Pipeline</strong>'a kaydolur.
            Yeni lead geldiğinde anında bildirim alırsınız.
          </p>
          <ul style={S.infoUl}>
            <li>✓ Auth gerekmez (public endpoint)</li>
            <li>✓ Honeypot field ile bot koruması</li>
            <li>✓ Rate-limit: IP başına dakikada 5 istek</li>
            <li>✓ CORS açık — herhangi bir site'den çağrılabilir</li>
          </ul>
        </div>

        {/* Önizleme */}
        <section style={S.section}>
          <h3 style={S.h3}>📋 Canlı Önizleme</h3>
          <div style={S.previewWrap}>
            <iframe
              title="Lead Form Önizleme"
              srcDoc={htmlSnippet}
              style={S.iframe}
              sandbox="allow-scripts allow-forms allow-same-origin"
            />
            <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)', marginTop: 8, textAlign: 'center' }}>
              Bu önizleme gerçek API'ye gönderir — doldurursanız <strong>{company?.code}</strong> şirketine lead düşer.
            </div>
          </div>
        </section>

        {/* HTML Kod */}
        <section style={S.section}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={S.h3}>📄 HTML/JS Embed Kodu</h3>
            <Button size="sm" onClick={() => copy(htmlSnippet, 'html')}>
              {copied === 'html' ? '✓ Kopyalandı' : '📋 Kopyala'}
            </Button>
          </div>
          <pre style={S.pre}>{htmlSnippet}</pre>
          <div style={S.usage}>
            <strong>Kullanım:</strong> Bu kodu sitenizin herhangi bir HTML sayfasına (örn. iletişim, ana sayfa, landing) yapıştırın.
            CSS'i siteinizin stiline göre düzenleyebilirsiniz.
          </div>
        </section>

        {/* API */}
        <section style={S.section}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <h3 style={S.h3}>⚡ REST API (Programatik)</h3>
            <Button size="sm" onClick={() => copy(apiSnippet, 'api')}>
              {copied === 'api' ? '✓ Kopyalandı' : '📋 Kopyala'}
            </Button>
          </div>
          <pre style={S.pre}>{apiSnippet}</pre>
          <div style={S.usage}>
            <strong>Kullanım:</strong> Chatbot, mobil uygulama veya başka entegrasyondan lead göndermek için.
            Yanıt: <code>{`{ success: true, data: { id: '<uuid>' } }`}</code>
          </div>
        </section>

        {/* Source örnekleri */}
        <section style={S.section}>
          <h3 style={S.h3}>🏷 Kaynak (Source) Önerileri</h3>
          <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', marginBottom: 12 }}>
            <code>source</code> alanı CRM Pipeline kartında ikon olarak görünür. Önerilen değerler:
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px,1fr))', gap: 8 }}>
            {[
              { v: 'web',       i: '🌐', l: 'Web Sitesi Formu' },
              { v: 'whatsapp',  i: '💬', l: 'WhatsApp' },
              { v: 'instagram', i: '📷', l: 'Instagram' },
              { v: 'facebook',  i: '📘', l: 'Facebook' },
              { v: 'google',    i: '🔎', l: 'Google Ads' },
              { v: 'fuar',      i: '🎪', l: 'Fuar' },
              { v: 'referans',  i: '🤝', l: 'Referans' },
              { v: 'soguk',     i: '❄', l: 'Soğuk Arama' },
              { v: 'telefon',   i: '📞', l: 'Telefon' },
            ].map(s => (
              <div key={s.v} style={S.sourceItem}>
                <span style={{ fontSize: 16 }}>{s.i}</span>
                <code style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>{s.v}</code>
                <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-secondary)', marginLeft: 'auto' }}>{s.l}</span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

const S = {
  infoBox: {
    padding: 14,
    background: 'var(--accent-glow)',
    border: '1px solid var(--border-primary)',
    borderRadius: 'var(--r-md)',
    marginBottom: 16,
  },
  infoP: { fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', margin: '8px 0', lineHeight: 1.6 },
  infoUl: { margin: '0', paddingLeft: 18, fontSize: 'var(--text-sm)', color: 'var(--text-secondary)' },
  section: {
    background: 'var(--bg-card)',
    border: '1px solid var(--border-secondary)',
    borderRadius: 'var(--r-md)',
    padding: 14,
    marginBottom: 14,
    boxShadow: 'var(--shadow-xs)',
  },
  h3: { fontSize: 'var(--text-md)', fontWeight: 700, color: 'var(--text-primary)', margin: 0 },
  previewWrap: {
    padding: 12,
    background: 'var(--bg-card-hover)',
    border: '1px dashed var(--border-secondary)',
    borderRadius: 'var(--r-md)',
  },
  iframe: { width: '100%', height: 420, border: 'none', background: '#fff', borderRadius: 6 },
  pre: {
    background: '#0f172a',
    color: '#e2e8f0',
    padding: 14,
    borderRadius: 'var(--r-md)',
    overflowX: 'auto',
    fontSize: 12,
    fontFamily: 'JetBrains Mono, monospace',
    lineHeight: 1.5,
    margin: 0,
  },
  usage: {
    fontSize: 'var(--text-xs)',
    color: 'var(--text-tertiary)',
    marginTop: 8,
    lineHeight: 1.5,
  },
  sourceItem: {
    display: 'flex', alignItems: 'center', gap: 8,
    padding: '8px 10px',
    background: 'var(--bg-card-hover)',
    border: '1px solid var(--border-secondary)',
    borderRadius: 'var(--r-sm)',
  },
};
